import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { Spinner, initializeIcons } from '@fluentui/react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from 'global/Application/AppInsight';
import { Constants } from 'global/Application/Constants';
import { AuthenticationProvider } from 'global/Authentication';
import 'index.css';
import 'normalize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './app/store';
import { DynamicThemeProvider } from "./global/themes";


initializeIcons();

const rootElement = document.getElementById('root');

ReactDOM.render(
    <React.StrictMode>
        <Spinner styles={{ root: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' } }} />
    </React.StrictMode>,
    rootElement
);


const registerServiceWorker = async () => {

    if ("serviceWorker" in navigator) {
        try {
            const registration = await navigator.serviceWorker.register("/service-worker.js", {
                scope: "/",
            });

            if (registration.installing) {
                console.log("Service worker installing");
            } else if (registration.waiting) {
                console.log("Service worker installed");
            } else if (registration.active) {
                console.log("Service worker active");
            }
        } catch (error) {
            console.error(`Registration failed with ${error}`);
        }
    }
};


Constants.initialize()
    .then(config => {
        //https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
        const msalInstance = new PublicClientApplication(Constants.msalConfig);

        registerServiceWorker();

        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <AppInsightsContext.Provider value={reactPlugin}>
                        <MsalProvider instance={msalInstance}>
                            <AuthenticationProvider>
                                <DynamicThemeProvider>
                                    <App />
                                </DynamicThemeProvider>
                            </AuthenticationProvider>
                        </MsalProvider>
                    </AppInsightsContext.Provider>
                </Provider>
            </React.StrictMode>,
            rootElement
        );

    }).catch(error => {
        ReactDOM.render(
            <React.StrictMode>
                <div>
                    <div>
                        Failed to load application
                    </div>
                    <div>{error.toString()}</div>
                </div>
            </React.StrictMode>,
            rootElement
        );
    });
